import AssetManagement from "./components/AssetManagement";
import StockAndSpareManagement from "./components/StockAndSpareParts";
import ServiceVendor from "./components/service_vendor";
import WorkOrderManagement from "./components/work_order_management";
import WorkplanManagement from "./components/workplan_management";

const maintenanceRouter = [
  {
    path: "/facility/maintenance/asset",
    element: <AssetManagement />,
  },
  {
    path: "/facility/maintenance/stock_and_spare_parts",
    element: <StockAndSpareManagement />,
  },
  {
    path: "/facility/maintenance/sla",
    element: <ServiceVendor />,
  },
  {
    path: "/facility/maintenance/workplan_management", 
    element: <WorkplanManagement />,
  },
  {
    path: "/facility/maintenance/work_order_management",
    element: <WorkOrderManagement />,
  },
];

export default maintenanceRouter;
